import * as types from './constants';

const initialState = {
  data: {
    uuid: '',
    name: '',
    rank: '',
    email: '',
    avatar_url: '',
    avatar_params: {},
    unmasking_status: '',
    is_discoverable: false,
    social_accounts: [],
    campaigns: []
  },
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Creator Details Public
  [types.GET_CREATOR_DETAILS_PUBLIC_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      data: initialState.data
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_PUBLIC_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_PUBLIC_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Get Creator Details Custom
  [types.GET_CREATOR_DETAILS_CUSTOM_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      data: initialState.data
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_CUSTOM_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_CUSTOM_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Get Creator Details Sendbird
  [types.GET_CREATOR_DETAILS_SENDBIRD_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      data: initialState.data
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_SENDBIRD_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_SENDBIRD_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_CREATOR_DETAILS_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

